import { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import api from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/password/forgot", { email }); setSent(true); }
    finally { setLoading(false); }
  };
  return <AuthLayout>
    <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Reset password</h1>
    <p className="mt-2 text-sm text-slate-500">Enter your email and we’ll send a secure reset link.</p>
    {sent ? <div className="mt-8 border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">If that account exists, a reset link has been sent.</div> :
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@company.com"
               className="w-full border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none focus:border-slate-900" />
        <button disabled={loading} className="w-full bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-60">{loading ? "Sending…" : "Send reset link"}</button>
      </form>}
    <Link to="/login" className="mt-6 block text-sm font-medium text-slate-700 underline underline-offset-2">Back to sign in</Link>
  </AuthLayout>;
}
